import React from 'react'
import { Container, Icon, Link, TextBody } from '@pmi/pmi-iqos-ds-react'

const SpotsMapsButton = ({ spot, translations }) => {
  return (
    <Container
      display={Container.displays.flex}
      flexDirection={Container.flexDirections.row}
      alignItems={Container.alignItemsValues.center}>
      <Container pr="2">
        <Icon size={Icon.sizes.xs} image={Icon.images.location} />
      </Container>
      <TextBody>
        <Link
          href={`https://www.google.com.sa/maps/search/${spot.lat},${spot.lng}?hl=en`}
          data-testing="SpotsMapsButton_Link_Maps">
          {translations.tk_goToGoogleMaps}
        </Link>
      </TextBody>
    </Container>
  )
}

export default SpotsMapsButton
